// extracted by mini-css-extract-plugin
export default {"group":"wYr5aZwBGJxoVMMsHQ9t","size-std":"NDC67HbN_EFSCZy3N3dA"};